# GraphQL mutation to update a stage name

#import "../fragments/sales-automation-stageset.graphql"

mutation UpdateStageset($stageset: UpdateStagesetInputFieldInput!) {
    updateStageset(input: {stageset: $stageset}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
